import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=cde7656a&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde7656a')) {
      api.createRecord('cde7656a', component.options)
    } else {
      api.reload('cde7656a', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=cde7656a&", function () {
      api.rerender('cde7656a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V86i30HdjsvT/JS/comp/ImgFallback2.vue"
export default component.exports